import { useState, useEffect } from 'react';

const COMPLIMENTS = [
  "You make me feel so included with your family",
  "You are so brave and willing to put yourself into uncomfortable situations",
  "You will do things that bore you if it means you can be with me, which is so sweet",
  "I love how hardworking you are, especially this summer with your classes, job, and living alone",
  "ur limbs are attractive lol <3",
  "You are willing to try things that I like to do, which is so cute",
  "YOU SNORKELING = HOT",
  "ur so adventurous and its so cute",
  "you make trips 1000000x better",
  "i love how we can just sit in silence and be happy",
  "ur little scream/ahhh when ur excited is so cute",
  "i wish i could keep u in my pocket",
  "i love how u wanna watch me play video games if u have a chair lol",
  "You have the cutest freckles and I love seeing them come out more and more during the summer",
  "U HAVE THE PRETTIEST SMILE AND CUTEST LAUGH",
  "You make me laugh everyday, even with the smallest things",
];

function getNextCSTMidnight() {
  const now = new Date();
  const cstNow = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  const nextMidnight = new Date(cstNow);
  nextMidnight.setHours(24, 0, 0, 0); // set to next midnight
  return nextMidnight;
}

const ComplimentGenerator = () => {
  const [compliment, setCompliment] = useState(null);
  const [showHeart, setShowHeart] = useState(false);
  const [isAvailable, setIsAvailable] = useState(true);
  const [countdown, setCountdown] = useState('');

  useEffect(() => {
    checkAvailability();
    let interval;
    if (!isAvailable) {
      interval = setInterval(updateCountdown, 1000);
      updateCountdown();
    }
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [isAvailable]);

  const checkAvailability = () => {
    const lastComplimentDate = localStorage.getItem('lastComplimentDate');
    const now = new Date();
    const cstNow = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    const today = cstNow.toDateString();

    if (lastComplimentDate === today) {
      setIsAvailable(false);
      const savedCompliment = localStorage.getItem('todaysCompliment');
      if (savedCompliment) {
        setCompliment(savedCompliment);
      }
    } else {
      setIsAvailable(true);
      setCompliment(null);
    }
  };

  const updateCountdown = () => {
    const now = new Date();
    const cstNow = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    const nextMidnight = getNextCSTMidnight();
    const diff = nextMidnight - cstNow;
    if (diff <= 0) {
      setCountdown('Available!');
      setIsAvailable(true);
      setCompliment(null);
      return;
    }
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    setCountdown(`${hours}h ${minutes}m ${seconds}s`);
  };

  const generateCompliment = () => {
    // Get the current index from localStorage
    const currentIndex = parseInt(localStorage.getItem('complimentIndex') || '0');

    // Get the compliment at the current index
    const newCompliment = COMPLIMENTS[currentIndex];

    // Move to the next index, cycling back to 0 when we reach the end
    const nextIndex = (currentIndex + 1) % COMPLIMENTS.length;

    setCompliment(newCompliment);
    setShowHeart(true);
    setIsAvailable(false);

    // Save to localStorage
    const now = new Date();
    const cstNow = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    localStorage.setItem('lastComplimentDate', cstNow.toDateString());
    localStorage.setItem('todaysCompliment', newCompliment);
    localStorage.setItem('complimentIndex', nextIndex.toString());

    // Hide heart after animation
    setTimeout(() => setShowHeart(false), 2000);
  };

  return (
    <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl p-8 animate-fade-in w-full h-full flex flex-col justify-center items-center">
      <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 via-pink-500 to-purple-600 mb-4">
        Daily Compliment
      </h2>

      {compliment ? (
        <div className="relative">
          <p className="text-xl text-purple-700 font-medium text-center mb-4">
            {compliment}
          </p>
          {showHeart && (
            <div className="absolute -top-4 -right-4 animate-bounce text-4xl">
              💖
            </div>
          )}
        </div>
      ) : (
        <p className="text-gray-600 text-center mb-4">
          {isAvailable ? "Ready for your daily boost?" : "Come back tomorrow for another compliment!"}
        </p>
      )}

      <button
        onClick={generateCompliment}
        disabled={!isAvailable}
        className={`w-full py-3 rounded-lg font-medium transition-all duration-300 transform hover:scale-105
          ${isAvailable
            ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:opacity-90'
            : 'bg-gray-200 text-gray-500 cursor-not-allowed'}`}
      >
        {isAvailable ? "RYAN COMPLIMENT" : "come tomorrow pls"}
      </button>

      {!isAvailable && (
        <div className="mt-4 text-center text-sm text-gray-500">
          Next compliment in: <span className="font-semibold text-purple-500">{countdown}</span>
        </div>
      )}
    </div>
  );
};

export default ComplimentGenerator; 